<template>
  <assign-personal-panel
    ref="panel"
    :config="tabConfig"
    :users-loading="usersLoading"
  />
</template>

<script>
import AssignPersonalPanel from '../AssignPersonalPanel.vue'

const tabConfig = {
  endpoint: '/iso/decision-makers',
  memberPlural: 'decision makers',
  addTitle: 'Add decision maker',
  addHint: 'Select a user, then add them to the decision maker team',
  listTitle: 'Decision makers list',
  emptyTitle: 'No decision makers yet',
  emptySearchTitle: 'No matching decision makers',
  emptyHint: 'Add your first decision maker above.',
  removeButtonTitle: 'Remove decision maker',
  loadError: 'Failed to load decision makers',
  addError: 'Failed to add decision maker',
  addSuccess: 'Decision maker added successfully',
  removeTitle: 'Remove this decision maker?',
  removeSuccess: 'Decision maker removed',
  removeError: 'Failed to remove decision maker',
}

export default {
  name: 'DecisionMakerTab',
  components: {
    AssignPersonalPanel,
  },
  props: {
    usersLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabConfig,
    }
  },
  methods: {
    fetchMembers() {
      return this.$refs.panel?.fetchMembers()
    },
  },
}
</script>
